import { render, staticRenderFns } from "./UserTrash.vue?vue&type=template&id=bef4d27c&scoped=true"
import script from "./UserTrash.vue?vue&type=script&lang=js"
export * from "./UserTrash.vue?vue&type=script&lang=js"
import style0 from "./UserTrash.vue?vue&type=style&index=0&id=bef4d27c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef4d27c",
  null
  
)

export default component.exports